/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Password_Label_Min_LengthInputs */

const nl_validation_password_label_min_length = /** @type {(inputs: Validation_Password_Label_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimaal 8 tekens`)
};

/**

* @param {Validation_Password_Label_Min_LengthInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const validation_password_label_min_length = /** @type {((inputs?: Validation_Password_Label_Min_LengthInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Password_Label_Min_LengthInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_validation_password_label_min_length(inputs)
});
export { validation_password_label_min_length as "validation.password.label_min_length" }